import {LocalAddress} from '../state/types/common.js';
import {getLogger} from '../logger.js';
import {GatewayNode} from '../node.js';

const log = getLogger('gateway.clients');

export type ClientInfo = {
    source: LocalAddress,
    lastAccess: number,
    onScavenge?: (this: ClientInfo) => void,
    onStop?: (this: ClientInfo) => void
};
export type Clients = Map<string, ClientInfo>

export function addClient(clients: Clients, node: GatewayNode, key: string, source: LocalAddress, onScavenge?: () => void, onStop?: () => void) {
    log.info(`adding client for key ${key}`);
    const client = {source, lastAccess: Date.now(), onScavenge, onStop};
    clients.set(key, client);
    try {
        node.addSource(source);
    } catch (e) {
        log.error(`Unable to add client for key ${key}`, e);
    }
}

export function removeClient(clients: Clients, node: GatewayNode, key: string) {
    log.info(`removing client for key ${key}`);
    const client = clients.get(key);
    if (client) {
        clients.delete(key);
        try {
            node.removeSource(client.source);
        } catch (e) {
            log.error(`Unable to remove client for ${key}`, e);
        }
    }
}
